export default "__VITE_ASSET__CcYE07CU__"